import React, { useState, useEffect } from "react";
import { ssoLogin,isSimplePwd } from '../../api/user'
import { useLocation } from 'react-router-dom';
import EditPassword from './editPassword'

const Login = () => {
  const location = useLocation();
  const [userName,setUserName] = useState('')
  const [pwdShow,setPwdShow] = useState(false)

   const handleCancel = () => {
    setPwdShow(false);
    window.location.href = "/"; 
  };
  useEffect(() => {
  //  localStorage.clear();
    const ticket = new URLSearchParams(location.search).get('ticket');
    ssoLogin({ ticket, redirectUrl: window.location.href }).then(res => {
      const { data, type } = res.result;
      console.log("res", res.result?.tokenValue);
       if(type==="unverified"){
         window.location.href = data
       }else{
          localStorage.setItem("token", res.result?.tokenValue);
          window.location.href = "/";   
          // isSimplePwd().then(ret=>{
          //   debugger
          //   const { isSimplePassword, userName: uname } = ret;
            
          //   if (isSimplePassword) {
          //     setUserName(uname)
          //     alert(1)
          
          //   }
          // }).catch(er=>{
          //   debugger
          //   console.log(er)
          // })
       }
      
    })
  }, []);
  
  return <EditPassword phone={userName} open={pwdShow} handleCancel={handleCancel} />;
};
export default Login;
